import React from 'react';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import user from '../Auth/user';
import compose from '../compose';
import DateFilter from './DateFilter';
import AssChart from './AssChart';
import {SumBy, ProportionTwoValues} from './Functions';

class InventoryTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      previousFilter: null,
      currentFilter: null,
      filters: [],
      inventoryChanges: null,
      data: [],
      filteredData: null
    };
  }

  fetchInventoryChanges = (startDate, endDate) => {
    const {firebase} = this.props;
    const {shopkeeperId} = this.props.user;

    firebase.database()
      .ref(`shopkeepers/${shopkeeperId}/inventoryChanges`)
      .orderByChild('date')
      .startAt(startDate.getTime())
      .endAt(endDate.getTime())
      .once('value', (snapshot) => {
        const allInventoryChanges = [];
        snapshot.forEach((data) => {
          const inventoryChange = {
            key: data.key,
            ...data.val()
          };

          allInventoryChanges.push(this.enhanceInventoryChange(inventoryChange));
        });
        const inventoryChanges = allInventoryChanges.filter((inventoryChange) => (inventoryChange.standName));
        this.setState({inventoryChanges, filteredData: inventoryChanges});
      });
  }

  enhanceInventoryChange = (inventoryChange) => {
    inventoryChange.soldItems = 0;
    inventoryChange.lostItems = 0;
    inventoryChange.addedItems = 0;
    inventoryChange.foundItems = 0;

    if (!inventoryChange.inventoryCheck) {
      if (inventoryChange.delta > 0) {
        inventoryChange.addedItems = Number(inventoryChange.delta);
      } else {
        inventoryChange.soldItems = -inventoryChange.delta;
      }
    } else {
      if (inventoryChange.delta > 0) {
        inventoryChange.foundItems = inventoryChange.delta;
      } else {
        inventoryChange.lostItems = (Number(inventoryChange.delta) === 0) ? Number(inventoryChange.delta) : - Number(inventoryChange.delta);
      }
    }

    inventoryChange.standName = inventoryChange.standId in this.props.stands ?
      this.props.stands[inventoryChange.standId].name : '';

    inventoryChange.productName = inventoryChange.productId in this.props.products ?
      this.props.products[inventoryChange.productId].name : '';

    return inventoryChange;
  }

  onNewFilter = (key, value) => {
    const filters = this.state.filters;
    filters[key] = value;
    this.setState({filters});
  }

  cancelFilter = (key) => {
    const filters = this.state.filters;
    delete filters[key];
    this.setState({filters});
  }

  onFilterChange = (filter) => {
    const filteredData = this.state.data.filter(filter);
    this.setState({filteredData});
  }

  onEnlargeToggled = () => {
    // Forces redraw but flashes the screen
    this.setState({display: 'none'});
    setTimeout(() => this.setState({display: 'block'}), 1);
  }

  render() {
    const boxProps = {
      style: this.props.boxStyle,
      data: this.state.filteredData,
      filters: this.state.filters,
      cancelFilter: this.cancelFilter,
      onNewFilter: this.onNewFilter,
      onEnlargeToggled: this.onEnlargeToggled
    };

    const {t} = this.props;

    return (
      <div>
        <DateFilter updateFunction={this.fetchInventoryChanges}/>
        <div style={{clear: 'both'}}></div>
        <div style={{
          display: 'flex',
          flexFlow: 'row wrap',
          justifyContent: 'space-between',
        }}>
          <AssChart {...boxProps}
            chartType='PieChart'
            title={t('dashboard.inventory.amountSalesProduct')}
            aggregate={new SumBy('productName', 'soldItems')} />

          <AssChart {...boxProps}
            chartType='PieChart'
            title={t('dashboard.inventory.amountSalesStand')}
            aggregate={new SumBy('standName', 'soldItems')} />

          <AssChart {...boxProps}
            chartType='PieChart'
            title={t('dashboard.inventory.lostItemsProduct')}
            aggregate={new SumBy('productName', 'lostItems')} />

          <AssChart {...boxProps}
            chartType='PieChart'
            title={t('dashboard.inventory.lostItemsStand')}
            aggregate={new SumBy('standName', 'lostItems')} />

          <AssChart {...boxProps}
            chartType='ColumnChart'
            isPercentChart={true}
            isStacked={true}
            title={t('dashboard.inventory.proportionLostAndSoldItemsProduct')}
            aggregate={new ProportionTwoValues('productName', 'lostItems', 'soldItems', t('dashboard.inventory.lost'), t('dashboard.inventory.sold'))} />

          <AssChart {...boxProps}
            chartType='ColumnChart'
            isPercentChart={true}
            isStacked={true}
            title={t('dashboard.inventory.proportionLostAndSoldItemsProduct')}
            aggregate={new ProportionTwoValues('standName', 'lostItems', 'soldItems', t('dashboard.inventory.lost'), t('dashboard.inventory.sold'))} />

        </div>
      </div>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(InventoryTab);



// WEBPACK FOOTER //
// ./src/Dashboard/InventoryTab.js